import React from 'react'
import { 
  Button,
  Box,
  Card,
  CardActions,
  CardContent,
  Chip,
  Divider,
  Dialog,
  DialogContent,
  DialogActions,
  DialogContentText,
  DialogTitle,
  Grid,
  InputLabel,
  MenuItem,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Tooltip,
  Typography
} from "@material-ui/core"
import Util from "../../common/Util"

class DeliveryDetailDialog extends React.PureComponent{
  constructor(props){
    super(props)
    this.renderItems = this.renderItems.bind(this)
  }

  renderItems(items){
      const { theme } = this.props
      return (
        <Table stickyHeader style={{marginTop:10}}>
          <TableHead>
            <TableRow>
              <TableCell>Item</TableCell>
              <TableCell>Cantidad</TableCell>
              <TableCell>Precio</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map((item, index)=>{
              return (
                <TableRow style={index%2==0?theme.table.row:theme.table.rowColor}>
                  <TableCell>{item.tktDisplayName}</TableCell>
                  <TableCell>{item.tktQt}</TableCell>
                  <TableCell>{Util.formatCurrency(item.tktPrice)}</TableCell>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      )
  }

  render(){
    const { open, onClose, delivery, order } = this.props
    console.log("ORDER DELIVERY", order, delivery)
    if(!order || !delivery){
      return null
    }
    return (
      <Dialog open={open} PaperProps={{style:{background:"#f6f6f6"}}} >
      <DialogTitle>
        <Typography variant="h1" color="primary">Detalle de pedido en viaje de {delivery.profile.proName}</Typography>
      </DialogTitle>
      <DialogContent style={{minWidth:500}}>
        <Card variant="outlined">
          <CardContent>
            <Typography>Pedido Nro. {order.ordNumber} {order.restaurant?`en ${order.restaurant.evtTitle}`:null}</Typography>
            <Typography>Hora de Compra {Util.timestampToMoment(order.tktBuyDate).format("HH:mm DD/MM")}</Typography>
            <Typography>Hora de Asignación {Util.timestampToMoment(delivery.lastDeliveryDate).format("HH:mm DD/MM")}</Typography>
            <Typography>Solicitado por {order.tktBuyerName} ({order.tktOwnerEmail})</Typography>
            <Typography>Total {Util.formatCurrency(order.ordTotal)}</Typography>
            {this.renderItems(order.orderItems)}
          </CardContent>
        </Card>
      </DialogContent>
        <DialogActions>
          <Tooltip title="Cerrar">
            <Button variant="contained" color="secondary" onClick={onClose}>Cerrar</Button>
          </Tooltip>
        </DialogActions>
      </Dialog>
    )
  }
}

export default DeliveryDetailDialog


// WEBPACK FOOTER //
// ./src/screens/deliverys/DeliveryDetailDialog.js